import React from 'react';
import { Fragment } from 'react'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { BellIcon, MenuIcon, XIcon } from '@heroicons/react/outline'
import { NavLink } from "react-router-dom";
import fugLogo from "../../assets/images/fug-logo.png";
import kanye from "../../assets/images/kanye.jpg";

const navigation = [
  { name: 'Home', href: '/', current: true },
  { name: 'Champs Are Here', href: '/champs', current: false },
  { name: 'Rules', href: '/rules', current: false },
  { name: 'History', href: '/history', current: false },
  { name: 'Suggest a Rule', href: '/new_rule', current: false},
  { name: 'Vote on Rules', href: '/vote_on_rules', current: false},
  { name: 'Ballots', href: '/ballots', current: false}
]

// function classNames(...classes) {
//   return classes.filter(Boolean).join(' ')
// }

function signOut(){
  localStorage.removeItem('token')
  window.location.reload();
}

export default function Navigation() {
  return (
    <Disclosure as="nav" className="bg-gray-800">
      {({ open }) => (
        <>
          <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
            <div className="relative flex items-center justify-between h-16">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                <div className="flex-shrink-0 flex items-center">
                  <img
                    className="block lg:hidden h-8 w-auto"
                    src={fugLogo}
                    alt="FUG"
                  />
                  <img
                    className="hidden lg:block h-12 w-auto"
                    src={fugLogo}
                    alt="Workflow"
                  />
                </div>
                <div className="hidden sm:flex items-center sm:ml-6">
                  <div className="flex max-h-9 space-x-4">
                    {navigation.map((item) => (
                      <NavLink
                        exact={true}
                        key={item.name} 
                        to={item.href} 
                        activeClassName='bg-gray-900 text-white'
                        className='nav-links text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium'
                      >
                        {item.name}
                      </NavLink>
                    ))}
                  </div>
                </div>
              </div>
              <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                <button className="bg-gray-800 p-1 rounded-full text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                  <span className="sr-only">View notifications</span>
                  <BellIcon className="h-6 w-6" aria-hidden="true" />
                </button>

                {/* Profile dropdown */}
                <Menu as="div" className="ml-3 relative">
                  <div>
                    <Menu.Button className="bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                      <span className="sr-only">Open user menu</span>
                      <img
                        className="h-8 w-8 rounded-full"
                        src={kanye}
                        alt=""
                      />
                    </Menu.Button>
                  </div>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <Menu.Item>
                        <span>
                          Your Profile
                        </span>
                      </Menu.Item>
                      <Menu.Item>
                        <span>
                          Settings
                        </span>
                      </Menu.Item>
                      <Menu.Item onClick={() => signOut()}>
                        <span>
                          Sign out
                        </span>
                      </Menu.Item>
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navigation.map((item) => (
                <NavLink
                  exact={true}
                  key={item.name} 
                  to={item.href} 
                  activeClassName='bg-gray-900 text-white'
                  className='nav-links text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium'
                >
                  {item.name}
                </NavLink>
                
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  )
}
